export const compareBetween = (from, to, comparison) => {
    return from.unix() <= comparison.unix() && to.unix() >= comparison.unix();
};
